module.exports = __webpack_public_path__ + "img/script-ip.30ac0011.png";